module.exports = __webpack_public_path__ + "static/media/paw.5ef6c0a2.svg";